import React, { Component } from 'react';

import CourseBox from '../CourseBox/Component';
import './style.css';

import cross_image from '../../imgs/cross.png'

class ScolarshipsTracker extends Component {
  onCourseClicked(course) {
    this.props.onCourseSelected(course.id);
  }

  render() {
    const coursesLength = this.props.courses.length;
    return <div className="scolarships-tracker container-fluid">
      <div className="instructions"><strong className="instructions">Becas Seleccionadas</strong></div>
      <div className="actions">
      {
        this.props.courses.map((course, i) => {
          return <React.Fragment key={ course.id }>
            <span><button className="tracker-item" onClick={ () => this.onCourseClicked(course) } key={ course.id }><img className="cross-img" width="16" height="16" alt="cross" src={ cross_image } />{ course.name }</button></span>
            {i === 1 ? null : <span className="separator">|</span>}
          </React.Fragment>
        })
      }
      { coursesLength < 2 ? <span className="alternate">¡Podes agregar una beca más!</span> : null }
      { coursesLength > 0 ? <a className="btn btn-primary" href="#inscripcion">Inscribirme</a> : null }
      </div>
    </div>
  }
}

class ValidScolarships extends Component {

  constructor() {
    super();
    this.onScolarshipSelected = this.onScolarshipSelected.bind(this);
  }

  onScolarshipSelected(id) {
    this.props.onScolarshipSelected(id);
  }

  render() {
    const courses = this.props.courses || [];
    const selected_courses = this.props.selected_courses || [];


    const Conditions = () => <p>
      Al participar del programa, estas aceptando nuestros <a href="http://becasenred.com.ar/basesycondiciones.html" rel="noopener noreferrer"  target="_blank">Terminos y condiciones</a>
    </p>;

    if (!this.props.age) {
      return  <section className="container course-selector">
        <div className="info-box">
          <h2 className="title">Becas Disponibles</h2>
          <p>Ingresa tu edad para conocer las becas a las que te podes anotar</p>
          <Conditions />
        </div>
        <hr />
      </section>
    }

    return <React.Fragment>
        { selected_courses.length >= 1 && !this.props.form_filled ? <ScolarshipsTracker onCourseSelected={ this.onScolarshipSelected } courses={ selected_courses } /> : null }
        <section className="container course-selector">
        <div className="info-box">
          <h2 className="title">Becas Disponibles</h2>
          <p>Elegí hasta 2 cursos y llena el formulario para inscribirte</p>
          <Conditions />
        </div>
        <div className="row">
          {
           courses
            .filter(course => ( (course.minAge <= this.props.age) && (course.maxAge >= this.props.age) ) )
            .sort(() => {
              if (Math.random() > 0.5) {
                return 1;
              }

              return -1;
            })
            .map(course => <div key={ course.id } className="col-xl-4 col-md-6"><CourseBox selected={ selected_courses.some(sc => sc.id === course.id) } onScolarshipSelected={this.onScolarshipSelected} course={course} elegible="true" /></div>)
          }
        </div>
        <hr />
      </section>
    </React.Fragment>
  }
}

export default ValidScolarships;



// WEBPACK FOOTER //
// ./src/components/ValidScolarships/Component.js